import { taskStatusToColor } from '../../model/utils/task-status';

import Styles from './styles.module.scss';

import type { TaskModel } from '../../model/types/task.model';

interface TitleProps {
	item: TaskModel;
	displayStatus?: boolean;
}

export const Title = ({ item, displayStatus = true }: TitleProps) => {
	const status = taskStatusToColor(item);
	return (
		<div className={Styles.titleContainer}>
			{displayStatus && <div className={`${Styles.iconContainer} ${Styles[status]}`} />}
			<p>{item.title}</p>
		</div>
	);
};
